// Whether two JSON-like values are alike: the same primitives, arrays of alike items in the same
// order, objects with alike values under the same keys in any order. A key whose value is
// undefined counts as left out, as JSON writes it. Not for class instances, maps or cycles.

export function deepEqual(a: unknown, b: unknown) : boolean {
    if (Object.is(a, b)) {
        return true;
    }
    if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) {
        return false;
    }
    if (Array.isArray(a) || Array.isArray(b)) {
        return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((item, index) => deepEqual(item, b[index]));
    }

    const left = a as Record<string, unknown>;
    const right = b as Record<string, unknown>;
    const keys = new Set([...Object.keys(left), ...Object.keys(right)]);
    for (const key of keys) {
        if (!deepEqual(left[key], right[key])) {
            return false;
        }
    }

    return true;
}
